import { combineReducers } from '@reduxjs/toolkit';

import getHub from './get_hub';
import getAllHubs from './get_all_hubs';
import getPop from './get_pop';
import getAllPops from './get_all_pops';

export default combineReducers({
    getAllHubs, getHub, getAllPops, getPop
});
